import {
  CollapsiblePanel,
  CollapsiblePanelContent,
  CollapsiblePanelItem,
  CollapsiblePanelTrigger,
} from '../../molecules/CollapsiblePanel/CollapsiblePanel';
import { SheetsStack } from '../../molecules/Sheets/SheetsStack';
import { PackageDetail } from '../PackageDetail/PackageDetail';
import { PackageListProps } from './PackageList.types';

export const PackageList = ({
  packages = [],
  microcopy,
  className = '',
  onOpenInUnityFromPackage,
  onAccordionChange,
}: PackageListProps) => {
  const isSinglePackage = packages.length === 1;
  const isPreviewMode = !onOpenInUnityFromPackage;

  const packageListTitle = (
    <h2 className="body-bold mb-6 mt-6 font-medium md:mb-8 md:mt-0">
      {microcopy.title}
    </h2>
  );

  if (isSinglePackage) {
    const pkg = packages[0];
    return (
      <section className={className}>
        <div className="hidden md:block">{packageListTitle}</div>
        <PackageDetail
          displayName={pkg.displayName}
          isEntitled={pkg.isEntitled}
          description={pkg.description}
          info={pkg.info}
          compatibility={pkg.compatibility}
          isSourceUpmRegistry={pkg.isSourceUpmRegistry}
          microcopy={microcopy.detail}
          onOpenInUnity={
            isPreviewMode ? undefined : () => onOpenInUnityFromPackage(pkg)
          }
          className="mt-8 md:mt-0"
        />
      </section>
    );
  }

  const mobileSheetDataWrapper = packages.map((pkg) => ({
    label: pkg.displayName ?? '',
    children: (
      <PackageDetail
        displayName={packages.length > 1 ? pkg.displayName : undefined}
        isEntitled={pkg.isEntitled}
        description={pkg.description}
        info={pkg.info}
        compatibility={pkg.compatibility}
        isSourceUpmRegistry={pkg.isSourceUpmRegistry}
        microcopy={microcopy.detail}
        onOpenInUnity={
          isPreviewMode ? undefined : () => onOpenInUnityFromPackage(pkg)
        }
        className="mt-8 md:mt-0"
      />
    ),
    microcopy: microcopy.sheet,
    parentSheetsTitle: microcopy.title,
  }));

  return (
    <section className={className}>
      <div className="hidden md:block">
        {packageListTitle}

        <CollapsiblePanel type="multiple" className="mt-8">
          {packages.map((pkg, i) => (
            <CollapsiblePanelItem key={pkg.id} value={`item-${i}`}>
              <CollapsiblePanelTrigger
                onValueChange={(value) =>
                  onAccordionChange?.(
                    pkg.displayName || 'Unknown package',
                    value ? 'open' : 'close'
                  )
                }
              >
                <h4>{pkg.displayName}</h4>
              </CollapsiblePanelTrigger>
              <CollapsiblePanelContent>
                <PackageDetail
                  isEntitled={pkg.isEntitled}
                  description={pkg.description}
                  info={pkg.info}
                  compatibility={pkg.compatibility}
                  isSourceUpmRegistry={pkg.isSourceUpmRegistry}
                  microcopy={microcopy.detail}
                  onOpenInUnity={
                    isPreviewMode
                      ? undefined
                      : () => onOpenInUnityFromPackage(pkg)
                  }
                />
              </CollapsiblePanelContent>
            </CollapsiblePanelItem>
          ))}
        </CollapsiblePanel>
      </div>

      <section className="block md:hidden">
        <SheetsStack
          sheets={mobileSheetDataWrapper}
          microcopy={microcopy.sheet}
          className="mt-8"
        />
      </section>
    </section>
  );
};
